import {createSlice, PayloadAction} from "@reduxjs/toolkit";

const defaultErrorMessage = "An error has occurred";

export interface ICommonStoreState{
  error: {
    isOpen: boolean;
    message: string;
    debugInfo?: string[];
  }
}

const initialState: ICommonStoreState = {
  error:{
    isOpen: false,
    message: defaultErrorMessage,
    debugInfo: [],
  }
};

export const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: (create) => ({
    errorReducer: create.reducer((state, action: PayloadAction<{isOpen: boolean, message: string, debugInfo?: string[]}>) => {
      state.error = {...state.error, isOpen: action.payload.isOpen, message: action.payload.message, debugInfo: action.payload.debugInfo};
    }),
  }),
  selectors: {
    errorMessageSelector: (state: ICommonStoreState) => state.error,
  }
});

export const commonReducer = commonSlice.reducer;